/**
 * Staff Portal Services Module
 * SDK services for staff portal operations.
 *
 * These services allow staff (employees) to manage their own HR data
 * through dedicated portal endpoints with role-based access control.
 *
 * Security:
 * - All requests require JWT authentication with "Staff" role
 * - Staff can only access their own data
 * - HROnly files are restricted from staff access
 * - Server validates user ownership for all operations
 */
// Base service
export { StaffPortalBaseService } from './StaffPortalBaseService';
// Leave operations
export { StaffPortalLeaveService } from './StaffPortalLeaveService';
// Leave document management
export { StaffPortalLeaveDocumentService } from './StaffPortalLeaveDocumentService';
// Profile management
export { StaffPortalProfileService } from './StaffPortalProfileService';
// File management
export { StaffPortalFileService } from './StaffPortalFileService';
// Models
export * from './models';
// Import for factory function
import { StaffPortalLeaveService } from './StaffPortalLeaveService';
import { StaffPortalLeaveDocumentService } from './StaffPortalLeaveDocumentService';
import { StaffPortalProfileService } from './StaffPortalProfileService';
import { StaffPortalFileService } from './StaffPortalFileService';
/**
 * Create all staff portal services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all staff portal services
 */
export function createStaffPortalServices(http, config) {
    const leaves = new StaffPortalLeaveService(http, config);
    const leaveDocuments = new StaffPortalLeaveDocumentService(http, config);
    const profile = new StaffPortalProfileService(http, config);
    const files = new StaffPortalFileService(http, config);
    return {
        leaves,
        leaveDocuments,
        profile,
        files,
    };
}
//# sourceMappingURL=index.js.map